import _ from 'underscore';

import { constants } from '@bingads-webui-campaign-react/image-experience-model';
import { getListOfEffectSettings } from '@bingads-webui-campaign/ad-creator-tools-instrumentation';

export const logSaveAdInfoForMetrics = ({
  data,
  saveAdActivity,
  enableAdCreatorMetrics,
  imageList = [],
  state = {},
}) => {
  const baseAdIdMessage = `SavedAdId: ${data.Id}`;

  if (enableAdCreatorMetrics) {
    const adIdMessage = [baseAdIdMessage];

    if (_.any(
      imageList,
      ({ source }) => source === constants.imageSources.WebsiteCarousel
    )) {
      adIdMessage.push('UsedWebsiteCarouselImage');
    }

    if (_.any(
      imageList,
      ({ source, isLogo }) => source === constants.imageSources.Website && !isLogo
    )) {
      adIdMessage.push('UsedWebsiteTabImage');
    }

    if (_.any(
      imageList,
      ({ source, isLogo }) => source === constants.imageSources.Website && isLogo
    )) {
      adIdMessage.push('UsedWebsiteTabImageForLogo');
    }

    if (_.any(
      imageList,
      ({ isLogo }) => isLogo
    )) {
      adIdMessage.push('UserAddedLogo');
    }

    if (state.hasManualCroppedImage) {
      adIdMessage.push('UserAppliedManualCrop');
    }

    if (state.hasManualCroppedLogo) {
      adIdMessage.push('UserAppliedManualCropToLogo');
    }

    if (state.hasUsedViewAllPlacements) {
      adIdMessage.push('UserOpenedViewAllPlacements');
    }

    saveAdActivity.trace(`${adIdMessage.join(';')};`);

    const effects = getListOfEffectSettings(imageList) || [];

    if (effects.length > 0) {
      _.each(effects, (effect) => {
        saveAdActivity.trace(`${baseAdIdMessage};SmartEffectUsed: ${effect};`);
      });
    }
  } else {
    saveAdActivity.trace(`${baseAdIdMessage};`);
  }
};
